import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, MatDialog } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { pushObjArray } from 'src/app/services/convert.service';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { AddAnswerExerciseBookClubComponent } from '../add-answer-exercise-book-club/add-answer-exercise-book-club.component';

@Component({
  selector: 'app-add-exercise-book-club',
  templateUrl: './add-exercise-book-club.component.html',
  styleUrls: ['./add-exercise-book-club.component.scss']
})
export class AddExerciseBookClubComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  form: FormGroup;
  question: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;
  TITLE = 'Add new question';


  constructor(
    public dialogRef: MatDialogRef<AddExerciseBookClubComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public store: BookstoreStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    const { QUESTION } = this.data;
    this.store.options = []
    this.form = this.fb.group({
      question: [QUESTION ? QUESTION.question : null, Validators.compose([Validators.required])],
    })
    this.question = this.form.controls['question'];
    if (QUESTION) {
      this.TITLE = "Edit question";
      const { answers } = QUESTION
      this.store.options = answers;
    }
  }

  delete(item: any) {
    this.store.options = this.store.options.filter(m => m.key !== item.key) || [];
  }

  addNewLine(item: any) {
    let dialogRef = this.dialog.open(AddAnswerExerciseBookClubComponent, {
      data: {
        QUESTION: this.data.QUESTION || {},
        ANSWER: item || null,
      },
      panelClass: 'item-list-panel',
      width: '35wh',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    this.isCreate = true;
    if (this.form.valid) {
      this.form.disable();
      const { question } = f;
      const { FORM, BOOK, QUESTION } = this.data;
      const { name } = FORM;
      const questions = BOOK ? BOOK.questions : null
      const row = {
        key: QUESTION ? QUESTION.key : this.ds.createId(),
        question,
        answers: this.store.options,
      };
      const QUESTION_DATA = pushObjArray(questions, row)
      BOOK.exerciseTip = name;
      BOOK.questions = QUESTION_DATA;
      this.store.saveBook(BOOK, (success, res) => {
        this.data.BOOK = BOOK;
        this.snackBar.open("Question has been saved successful.", "Done", { duration: 1000 });
        if (!isNew) {
          this.dialogRef.close('no')
          return;
        }
        this.store.options = []
        this.form.reset();
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.isCreate = false;
        this.inputEl.nativeElement.focus()
      })
    }
    else {
      this.processNew = false;
      this.processClose = false;
      this.isCreate = false;
    }
  }
}
